var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/form/form.tsx";
const _excluded = ["onSubmit", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
/** Form element with custom styles. */
const Form = _ref => {
  let {
      onSubmit,
      children
    } = _ref,
    filteredProps = _objectWithoutProperties(_ref, _excluded);
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    if (onSubmit) {
      onSubmit(event);
    }
  }, [onSubmit]);
  return /*#__PURE__*/React.createElement("form", _extends({
    "data-testid": "form",
    onSubmit: handleSubmit,
    className: "space-y-4"
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }), children);
};
export default Form;